<div *ngIf="formControl">
  <mat-form-field class="control-input">
    <input [formControl]="formControl" (blur)="onBlur()" matInput [id]="id" [name]="name" [placeholder]="label" [ngStyle]="textAlignStyle" />
  </mat-form-field>
  <app-control-error [control]="formControl" [offset]="-16"></app-control-error>
</div>
